import type { SupplierCertificateType } from '@tandemone/types'

import { Badge } from '@/components/ui/badge'
import { SUPPLIER_CERTIFICATE_LABELS } from '@/domains/supplier-onboarding'

import { getCertFamily } from './cert-family'

const CERTIFICATIONS_VISIBLE = 3

type Props = {
  certifications: SupplierCertificateType[]
}

export function CertificationsCell({ certifications }: Props) {
  if (certifications.length === 0) {
    return <span className='text-xs text-muted-foreground'>—</span>
  }
  const visible = certifications.slice(0, CERTIFICATIONS_VISIBLE)
  const remaining = certifications.length - visible.length
  return (
    <div className='flex flex-wrap items-center gap-1 sm:flex-nowrap'>
      {visible.map(cert => (
        <Badge
          key={cert}
          className={`shrink-0 whitespace-nowrap font-normal ${getCertFamily(cert).className}`}
        >
          {SUPPLIER_CERTIFICATE_LABELS[cert] ?? cert}
        </Badge>
      ))}
      {remaining > 0 && (
        <Badge variant='outline' className='shrink-0 font-normal'>
          +{remaining}
        </Badge>
      )}
    </div>
  )
}
